var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('b-container',{staticClass:"p-0 m-0 no-x-scroll",attrs:{"fluid":""}},[_c('NavBar'),_c('router-view'),_c('Footer',{attrs:{"id":"support"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }